
import * as React from 'react';
import { Link } from "react-router-dom";
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import '../../assets/css/CampaignFooter.css';


function Footer() {
  const [visible, setVisible] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("terms");

  const toggleDialog = () => setVisible(!visible);

  return (
    <footer className="campaign-footer">
      <div className="footer-bottom text-center">
        <div className="container">
          <div className="campaign-footer-row">
            <div className="campaign-footer-col about-col">
              <p className="footer-about-text">Empowering the Construction Community</p>
            </div>
            <div className="campaign-footer-col social-col">
              <div className="footer-widget footer-about">
                <ul className="footer-social">
                  <li>
                    <a href="https://www.facebook.com/mybuilderid" aria-label="Facebook">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/mybuilderid" aria-label="Twitter">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/mybuilderid/" aria-label="Instagram">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/my-builder-id/" aria-label="LinkedIn">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@mybuiderid.com" aria-label="Email">
                      <i className="fa fa-envelope"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="campaign-footer-col terms-col">
              <div className="terms-conditions" onClick={toggleDialog}>
                Terms and Conditions
              </div>
            </div>
          </div>
        </div>
      </div>

      {visible && (
        <Dialog title=" " onClose={toggleDialog} width="60vw" height="85vh">
          <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "10px", gap: '14px' }}>
            <Button
              style={{
                background: activeTab === "terms" ? "#162d61" : "#E0E0E0",
                color: activeTab === "terms" ? "#FFF" : "#000",
                cursor: "pointer",
              }}
              onClick={() => setActiveTab("terms")}
            >
              Terms and Conditions
            </Button>
            <Button
              style={{
                background: activeTab === "privacy" ? "#162d61" : "#E0E0E0",
                color: activeTab === "privacy" ? "#FFF" : "#000",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => setActiveTab("privacy")}
            >
              Privacy Policy
            </Button>
          </div>

          {activeTab === "terms" && (
            <iframe
              src="https://www.iubenda.com/terms-and-conditions/90161377"
              width="100%"
              height="90%"
              style={{ border: "none" }}
              title="Terms and Conditions"
            ></iframe>
          )}
          {activeTab === "privacy" && (
            <iframe
              src="https://www.iubenda.com/privacy-policy/90161377"
              width="100%"
              height="90%"
              style={{ border: "none" }}
              title="Privacy Policy"
            ></iframe>
          )}
        </Dialog>
      )}
    </footer>
  );
}

export default Footer;
